import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToAnchor = () => {
  const location = useLocation();
  const lastHash = useRef('');

  useEffect(() => {
    // If there's a hash in the URL
    if (location.hash) {
      lastHash.current = location.hash.slice(1); // remove the #
    }

    // Give React time to render the target element (important when coming from another page)
    const timer = setTimeout(() => {
      const hash = lastHash.current;
      if (hash) {
        const element = document.getElementById(hash);
        if (element) {
          const yOffset = -120; // ← CHANGE THIS to your navbar height + buffer (e.g. -100, -140)
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({ top: y, behavior: 'smooth' });
          lastHash.current = ''; // reset so it doesn't repeat
        }
      }
    }, 100); // small delay — 50–300ms usually enough

    return () => clearTimeout(timer);
  }, [location]);

  return null;
};

export default ScrollToAnchor;